/* eslint-disable no-console */
import React, {useEffect, useRef, useState} from 'react'
import {useForm} from 'react-hook-form'
// import {toast} from 'react-toastify'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {CheckboxField, Spinner} from 'helpers'
import {OrganizationTypeList} from 'models/dropdown'
import {ColumnProps, IFormField} from 'models/Common'
import KTTable from 'helpers/ui-components/KTTable'
import {IOrgMapping} from 'models/UserManagement'
import {
 createOrgMapping,
 fetchOrganisationTypes,
 fetchOrgMappingList,
} from 'utils/api/auth/userManagementService'
import IAuth from 'models/Auth'
import {toast} from 'react-toastify'
import {KTSearchBox} from 'helpers/ui-components/KTSearchBox'
import {Link} from 'react-router-dom'
import {KTFilterBox} from 'helpers/ui-components/KTFilterBox'
import {fetchFilterConfig} from 'utils/api/auth/commonService'
import {createFilterPayload} from 'utils/helpers/genericFilterForm'
// import {ILogin} from 'models/Auth'
type IProps = {
 userId: string
 activeTabId: number
 loggedInUser: IAuth | undefined
 userCategoryKey?: string
 setLoader: (newState: boolean) => void
 handleTabClick: (
  newState: number,
  isBackBtnClick: boolean
 ) => void
}

type FormValues = {
 selectedIds: string[]
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const NetworkMapping = (props: IProps) => {
 const {t} = useTranslation()
 const [currentPage, setCurrentPage] = useState(1)
 const [totalRecord, setTotalRecord] = useState(0)
 const [searchTerm, setSearchTerm] = useState('')
 const [itemsPerPage, setItemsPerPage] = useState(25)
 const [selectedCategory, setSelectedCategory] =
  useState('all')
 const [tableColList, setTableColList] = useState<
  Array<ColumnProps<IOrgMapping>>
 >([])
 const [categoryList, setCategoryList] = useState<
  OrganizationTypeList[]
 >([])
 const [orgMappingTableRows, setOrgMappingTableRows] =
  useState<IOrgMapping[]>([])
 const {register, watch, handleSubmit, setValue} =
  useForm<FormValues>({
   mode: 'all',
   reValidateMode: 'onChange',
   defaultValues: {selectedIds: []},
  })
 const [filterFormData, setFilterFormData] = useState({})
 const [loader, setLoader] = useState(false)
 const [filterConfig, setFilterConfig] = useState<
  IFormField[]
 >([])
 const [filterCount, setFilterCount] = useState(0)
 const [filterParam, setFilterParam] = useState<string>('')
 const [showTypeFilter, setShowTypeFilter] = useState(false)
 const isInitialMount = useRef(true)
 const renderTableData = async (
  showOfftakerType: boolean
 ) => {
  props.setLoader(true)

  const columns: Array<ColumnProps<IOrgMapping>> = [
   {
    key: 'name',
    title: t(
     'userManagement.activate.networkMapping.orgName'
    ),
   },
   {
    key: 'district',
    title: t(
     'userManagement.activate.networkMapping.location'
    ),
   },
   {
    key: 'category',
    title: t(
     'userManagement.activate.networkMapping.orgType'
    ),
    render: (_, record) => {
     return record?.category?.name
    },
   },
   ...(showOfftakerType
    ? [
       {
        key: 'offtaker_type',
        title: 'Offtaker Type',
        render: (_: unknown, record: IOrgMapping) => {
         return record?.offtaker_type ?? '-'
        },
       },
      ]
    : []),

   {
    key: 'currentlyAssignedTo',
    title: t(
     'userManagement.activate.networkMapping.currentlyAssignedTo'
    ),
    render: (_, record) => {
     return record?.mapped_users?.[0] ? (
      <Link
       target='_blank'
       rel='noreferrer'
       className='w-full text-[#4E83E4] underline'
       to={`/user-details/${record?.mapped_users[0]?.id}`}
      >
       {record?.mapped_users[0]?.full_name}
      </Link>
     ) : (
      <span className='text-[#C5CED6]'>
       {t('userManagement.activate.geoMapping.notAssigned')}
      </span>
     )
    },
   },
   {
    key: 'action',
    title: t('userManagement.activate.geoMapping.action'),
    className: '!text-center',
    render: (_, record) => {
     const disabled = record?.mapped_users?.[0]?.id
      ? record.mapped_users[0].id !== Number(props.userId)
      : false
     return (
      <div
       className='w-full flex justify-center items-center'
       key={record?.id}
      >
       <div
        className={`${
         disabled && 'text-[#C5CED6] border-[#E6EBF0]'
        } flex justify-center items-center w-[118px] h-12 rounded-lg border border-[#4E83E4] cursor-pointer text-[#4E83E4] font-semibold text-center
    shadow-[0_4px_4px_0_rgba(0, 0, 0, 0.12)] bg-white px-1 py-[3px]`}
       >
        <CheckboxField
         type='checkbox'
         disabled={disabled}
         label={''}
         className={`activate-user-checkbox w-5 h-5 mt-1 text-blue-600 bg-gray-100 rounded border-gray-300 border-neutral-30`}
         wrapperClassName=''
         defaultChecked={disabled}
         value={record.id.toString()}
         name={`selectedIds`}
         id={`selectedIds-${record.id}`}
         register={register(`selectedIds`, {
          required: false,
         })}
        />
        <span
         className={`${
          disabled && 'text-[#C5CED6]'
         } text-base font-semibold ml-1`}
        >
         {disabled ||
         (watch(`selectedIds`).length > 0 &&
          watch(`selectedIds`)?.includes(
           record.id.toString()
          ))
          ? t('userManagement.activate.geoMapping.added')
          : t('userManagement.activate.geoMapping.add')}
        </span>
       </div>
      </div>
     )
    },
   },
  ]
  setTableColList(columns)
  props.setLoader(false)
 }

 const getOrgMapping = async (
  page: Number,
  param?: string
 ) => {
  props.setLoader(true)
  const payload = await createFilterPayload(
   filterConfig,
   filterFormData
  )
  setFilterCount(payload.totalAppliedFilters)
  delete payload.totalAppliedFilters

  let assigendForOwn: string[] = []
  const res = await fetchOrgMappingList({
   page,
   page_size: itemsPerPage,
   user_id: props.userId,
   type:
    selectedCategory === 'all'
     ? filterParam || param
     : selectedCategory,
   ...(searchTerm && {search: searchTerm}),
   ...payload,
  })

  if (res) {
   const orgList: IOrgMapping[] = res.results
   const showOfftakerType = orgList.some((item) =>
    Object.prototype.hasOwnProperty.call(
     item,
     'offtaker_type'
    )
   )

   setTotalRecord(res.count ?? 0)
   assigendForOwn = orgList
    .filter(
     (val) =>
      val?.mapped_users &&
      val.mapped_users.some(
       (user) => user.id === Number(props.userId)
      )
    )
    .map((item) => item.id.toString())

   setValue('selectedIds', assigendForOwn)
   setOrgMappingTableRows(orgList)
   await renderTableData(showOfftakerType)
  }

  props.setLoader(false)
 }

 const handlePageChange = async (pageNo: number) => {
  setCurrentPage(pageNo)
  await getOrgMapping(pageNo)
 }

 const getFilterConfigs = async () => {
  const res = await fetchFilterConfig({
   filter_type: 'USER',
   filter_key: 'ORGANISATION_MAPPING_FILTERS',
  })

  if (res) {
   setFilterConfig(res?.applicableFilters ?? [])
  }
 }

 async function submitFormData(formData: IFormField) {
  if (formData?.selectedIds?.length > 0) {
   props.setLoader(true)
   const payload = {
    user_id: props.userId,
    organisation_ids: formData.selectedIds,
   }
   console.log('payload', payload, formData)
   const res = await createOrgMapping(payload)
   if (res) {
    toast.success(res)
    props.handleTabClick(props.activeTabId, false)
   }
   props.setLoader(false)
  } else {
   toast.error(t('errors.pleaseSelectOrg'))
  }
 }

 useEffect(() => {
  const getCategories = async () => {
   props.setLoader(true)
   const res: OrganizationTypeList[] =
    await fetchOrganisationTypes(
     props.userCategoryKey
      ? {user_category_key: props.userCategoryKey}
      : undefined
    )
   let paramString = ''
   if (res?.length > 1) {
    paramString = res.map((item) => item.key).join(',')
    setShowTypeFilter(true)
    setFilterParam(paramString)
    setCategoryList([
     {
      key: 'all',
      display_name: 'All',
     },
     ...res,
    ])
   } else if (res?.length === 1) {
    paramString = res[0].key
    setShowTypeFilter(false)
    setFilterParam(paramString)
    setCategoryList([])
   } else {
    setShowTypeFilter(false)
    setFilterParam('')
    setCategoryList([])
   }
   void getOrgMapping(currentPage, paramString)
   props.setLoader(false)
  }
  void getCategories()
 }, [])

 useEffect(() => {
  if (isInitialMount.current) {
   isInitialMount.current = false
   return
  }
  void getOrgMapping(currentPage)
 }, [
  currentPage,
  itemsPerPage,
  selectedCategory,
  searchTerm,
  filterFormData,
 ])

 useEffect(() => {
  setCurrentPage(1)
 }, [itemsPerPage, selectedCategory, searchTerm])

 useEffect(() => {
  void getFilterConfigs()
 }, [])

 return (
  <>
   {loader && (
    <div className='fixed inset-0 z-[9999] flex items-center justify-center bg-black/30'>
     <Spinner />
    </div>
   )}
   <div className='w-full'>
    <div className='text-[#171B1F] text-lg font-normal'>
     {t('userManagement.activate.networkMapping.title')}
    </div>
    <div>
     <KTSearchBox
      label={t('userManagement.activate.search')}
      placeholder={t(
       'userManagement.activate.networkMapping.searchText'
      )}
      wrapperClass='my-6 !p-3'
      setSearchTerm={setSearchTerm}
     />
     <KTFilterBox
      parentId={'organisation'}
      btnText={t('helperText.filter')}
      containerClass='flex-wrap items-start gap-y-2'
      filterConfig={filterConfig}
      setLoader={setLoader}
      filterCount={filterCount}
      filterFormData={filterFormData}
      setFilterFormData={(data) => {
       setFilterFormData(data)
       setCurrentPage(1)
      }}
     >
      {showTypeFilter && (
       <div className='ml-4 flex min-w-0 flex-1 flex-wrap items-center gap-x-6 gap-y-2'>
        {categoryList.map((val, key) => (
         <div
          key={key}
          onClick={() => {
           setSelectedCategory(val.key)
          }}
          className={`text-center py-[6px] px-2 rounded-lg text-sm border font-normal cursor-pointer
        ${
         selectedCategory === val.key
          ? 'bg-[#33393D] text-white border-[#33393D]'
          : 'bg-white text-[#33393D] border-[#CED8E0] hover:bg-[#33393D] hover:text-white'
        }`}
         >
          {val.display_name}
         </div>
        ))}
       </div>
      )}
     </KTFilterBox>
    </div>
    <form
     method='POST'
     action=''
     onSubmit={handleSubmit(submitFormData)}
    >
     <div className='w-full'>
      <div className='w-full mt-2'>
       <KTTable
        data={orgMappingTableRows}
        columns={tableColList}
        headerClass='bg-[#80868C]'
        headerColClass='!border-0 text-left'
        colClass='text-[#33393D] !text-sm font-normal !border-0'
        tableClass=''
        rowClass='even:bg-[#E6EBF0]'
        showPagination={true}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        totalRecord={totalRecord}
        setItemsPerPage={setItemsPerPage}
        onPageChange={handlePageChange}
       />
      </div>
     </div>
     {/* {orgMappingList?.length > 0 && ( */}
     <div className='w-full bg-white py-6'>
      <div className='flex items-center justify-end pr-[72px]'>
       <Button
        type='button'
        disabled={false}
        onClick={() => {
         props.handleTabClick(props.activeTabId, true)
        }}
        color='white'
        className='text-center py-[9px] px-6 bg-white 
                  !rounded-lg text-base text-[#4E83E4] hover:bg-[#4E83E4] font-semibold border-[#4E83E4] mr-2'
       >
        {t('userManagement.activate.back')}
       </Button>
       <Button
        type='submit'
        disabled={false}
        color='blue'
        className='text-center py-[9px] px-6 bg-[#4E83E4] 
                  !rounded-lg text-base text-white font-semibold border-[#4E83E4]'
       >
        {t('userManagement.activate.saveNNext')}
       </Button>
      </div>
     </div>
     {/* )} */}
    </form>
   </div>
  </>
 )
}

export default NetworkMapping
